import React from "react";
import { useTranslation } from "react-i18next";
import Profile from "../../../assets/images/profile1.png";
import { useSelector } from "react-redux";

import "./styles.scss";

const Greetings = () => {
  const { username } = useSelector((state) => state.auth);
  const [t] = useTranslation("dashboard");

  return (
    <div id="greetings">
      <div className="d-flex align-items-center">
        <img src={Profile} alt="profile" />
        <div className="mx-2">
          <h3>
            {t("greetings.hi")}, {username}!
          </h3>
        </div>
      </div>
    </div>
  );
};

export default Greetings;
